import { useEffect, useState } from 'react';
import { Alert, Button, Spinner } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import { useBranch } from '../../../context/BranchContext';
import axiosInstance from '../../../services/AxiosInstance';
import Api from '../../../constants/Api';
import AppointmentDashboard from './AppointmentDashboard';

export default function AppointmentStandalone() {
    const [params] = useSearchParams();
    const branchId = params.get('branch');
    const { setBranches, setSelectedBranch } = useBranch();
    const [status, setStatus] = useState('loading');
    const [attempt, setAttempt] = useState(0);

    useEffect(() => {
        let active = true;
        setStatus('loading');
        // Sem o header, esta tela inicializa a filial usando somente as unidades
        // autorizadas pela API. A agenda só monta depois de restaurar esse contexto.
        axiosInstance.get(`${Api.main.branch}/user`).then(({ data }) => {
            if (!active) return;
            const branch = data.find((item) => String(item.id) === branchId);
            if (branchId && !branch) {
                setStatus('unavailable');
                return;
            }
            setBranches(data);
            setSelectedBranch(branch || null);
            setStatus('ready');
        }).catch(() => {
            if (active) setStatus('error');
        });
        return () => { active = false; };
    }, [branchId, attempt, setBranches, setSelectedBranch]);

    if (status === 'loading') return <div className="p-4" role="status"><Spinner size="sm" /> Carregando agenda…</div>;
    if (status !== 'ready') return (
        <Alert variant="warning" className="m-3">
            <p>{status === 'unavailable' ? 'A filial desta agenda não está disponível para seu usuário.' : 'Não foi possível carregar a agenda.'}</p>
            <Button onClick={() => setAttempt((value) => value + 1)}>Tentar novamente</Button>{' '}
            <a href="/appointment/dashboard">Voltar ao sistema</a>
        </Alert>
    );

    return <AppointmentDashboard standalone />;
}
